import * as Sentry from '@sentry/react';
import PolyglotMissingKey from 'App/Errors/PoliglotMissingKeyError';
import { consoleInfoLog } from 'App/Helpers';

/**
 * @param {string} key
 */
export default function polyglotOnMissingKey(key) {
    if (process.env.NODE_ENV === 'production') {
        Sentry.captureException(new PolyglotMissingKey(key));
    } else {
        consoleInfoLog(`Polyglot Key Missing: ${key}`, 'fail');
    }
}
